import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { YouthSearchURL } from './youth-quick-search-url.config';

@Injectable({
  providedIn: 'root'
})
export class YouthQuickSearchService {

  constructor(private httpService: HttpService) { 
    //Do Nothing
  }

  searchYouth(data){
    return this.httpService.post(YouthSearchURL.EndPoints.youthsearch, data);
  }


  getYouthNoteBookActiveVersionId(){
    return this.httpService.get(YouthSearchURL.EndPoints.getYouthNoteBookPage);
  }

  getGenderValues(){
    return this.httpService.get(YouthSearchURL.EndPoints.getYouthGenderList);
  }
}
